import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "max-w-screen-2xl mx-auto px-4 md:px-10" }
const _hoisted_2 = { class: "bg-white rounded-xl px-8 md:px-16 py-12 font-light" }

import { computed } from "vue";
import { useI18n } from "vue-i18n";
import BaseHeadline from "@/components/baseHeadline.vue";
import DiamondDetailFluorescenceContent from "@/components/diamonds/details/DiamondDetailFluorescenceContent.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'DiamondDetailFluorescence',
  props: {
    fluorescence: {}
  },
  setup(__props: any) {

const { t } = useI18n();

const props = __props;

const getNormalizedFluorescence = (f: string) => {
  if (!f) return "n";
  f = f.toUpperCase();
  if (f === "N" || f === "NONE" || f === "NON" || f === "KEINE") return "n";
  if (
    f === "SL" ||
    f === "SLIGHT" ||
    f === "WEAK" ||
    f === "SCHWACH" ||
    f === "FAINT"
  )
    return "sl";
  if (f === "F" || f === "MEDIUM" || f === "MITTEL") return "f";
  return f.toLowerCase();
};

const fluorescences = [
  { key: "f", label: "Medium" },
  { key: "sl", label: "Weak" },
  { key: "n", label: "None" },
];

const initialFluorescenceLabel = computed(() => {
  const fluorescenceValue = Array.isArray(props.fluorescence)
    ? props.fluorescence[0]
    : props.fluorescence;
  const normalized = getNormalizedFluorescence(fluorescenceValue);
  const found = fluorescences.find((f) => f.key === normalized);
  return found ? found.label : fluorescenceValue;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(DiamondDetailFluorescenceContent, { fluorescence: __props.fluorescence }, {
        title: _withCtx(() => [
          _createVNode(BaseHeadline, { class: "!text-2xl mb-6 !normal-case !tracking-normal" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("components.diamonds.details.fluorescence.title")) + ": " + _toDisplayString(initialFluorescenceLabel.value), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["fluorescence"])
    ])
  ]))
}
}

})